<template>
  <div>
    <main class="container-fluid">
      <section class="row">
        <div class="col-4 px-3 py-3 d-none d-md-flex"></div>
        <div class="col-md-16 px-3 py-3 ">
          <div class="col d-column">
            <h1 class="title pt-2 mb-0" v-text="$ml.get('progPubTitle')"></h1>
            <h1 class="title">
              <span v-text="$ml.get('progPubSubTitle')" class="pb-2"></span>
            </h1>
            <div class="card mb-3">
              <div class="card-body">
                <div class="d-column flex-row">
                  <div class="loading d-flex ">
                    <div v-if="loading" class="c-loader"></div>
                    <h6
                      v-else
                      v-show="!listProgram.length"
                      class="p-1"
                      v-text="
                        $ml.get('youDontHaveAnyProgramsInThisCategoryYet')
                      "
                    >
                      Você ainda não possui programas nessa categoria
                    </h6>
                  </div>
                  <TimelineProgram :listProgram="listProgram" />
                </div>
              </div>
            </div>
          </div>
          <div v-show="totalPages > 10 && !loading" class="mb-2">
          <b-pagination
            v-model="pageActive"
            :total-rows="totalPages"
            :per-page="10"
            :prev-text="$ml.get('previous')"
            :next-text="$ml.get('next')"
            align="right"
          >
          </b-pagination>
        </div>
        </div>    
      </section>    
    </main>
  </div>
</template>

<script>
import ProgramService from "../../../services/program.service";
import TimelineProgram from "../../../components/company/timelineProgram";

export default {
  components: {
    TimelineProgram,
  },
  data() {
    return {
      title: "published",
      listProgram: [],
      loading: true,
      pageSize:10,
      pageActive: 0,
      totalPages: 0,
    };
  },
  mounted() {
    this.changeProgram();
  },
  watch:{
    pageActive(){
      this.changeProgram();
    }
  },
  methods: {
    changeProgram() {
      this.loading = true;
      ProgramService.getProgram("showReports=true&status=in_progress", this.pageActive, this.pageSize).then(
        (response) => {
          this.loading = false;
          this.listProgram = response.data.items;
          this.totalPages = response.data.total
        },
        () => {
          this.loading = false;
        }
      );
    },
  },
};
</script>
